module.exports = __webpack_public_path__ + "static/media/28_Obayda_Syrische_Familie_webfinal.348664b3.jpg";